export function getCurrentHeaderHeight(offset = 0): number {
  return document.getElementsByTagName("header")[0]?.clientHeight || 0 + offset;
}
